import axios from 'axios';
import env from '@/env';
import interceptorRequest from '@/services/interceptors/request';
import interceptorResponseError from '@/services/interceptors/responseError';
import interceptorResponseSuccess from '@/services/interceptors/responseSuccess';

const http = axios.create({
  baseURL: env.REAL_API_URL,
});

http.interceptors.request.use(interceptorRequest);
http.interceptors.response.use(interceptorResponseSuccess, interceptorResponseError);

function authorizeApi(token) {
  if (token) {
    http.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete http.defaults.headers.common.Authorization;
  }
}

export default http;
export { authorizeApi };
